import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { AbstractControl, NG_VALUE_ACCESSOR, NG_VALIDATORS, ValidationErrors } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-app/shared/control-value-accessor-validator-base';
import { Animations } from '@fi-shared/utils/animations';
import { FiToggleSwitchSliderColorClass } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.component';

export interface IUserActivationDateFilter {
    FilterUsersByActivationDate: boolean;
    UserActivationDate?: string;
}

@Component({
    selector: 'fi-onboarding-user-activation-date-filter',
    templateUrl: './fi-onboarding-user-activation-date-filter.component.html',
    styleUrls: ['./fi-onboarding-user-activation-date-filter.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-user-activation-date-filter' },
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiOnboardingUserActivationDateFilterComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiOnboardingUserActivationDateFilterComponent,
            multi: true,
        },
    ],
    animations: [Animations.fadeWidth()],
})
export class FiOnboardingUserActivationDateFilterComponent extends ControlValueAccessorValidatorBase<IUserActivationDateFilter> {
    protected onFilterToggleChange(isEnabled: boolean): void {
        this.ngModel.FilterUsersByActivationDate = isEnabled;
        this.ngModel.UserActivationDate = undefined;
        this.doPropagateChanges();
    }

    public doValidate(c: AbstractControl): ValidationErrors {
        return {
            'no-filter-date-provided': !!this.ngModel.FilterUsersByActivationDate && !this.ngModel.UserActivationDate,
        };
    }

    protected readonly FiToggleSwitchSliderColorClass = FiToggleSwitchSliderColorClass;
}
